import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Youtube, Facebook, GitHub } from 'react-feather';
import { getAuth, signOut } from 'firebase/auth';
import '../styles/Home.css';
import logo from '../assets/logo1.png';
import Border1 from '../assets/topborder1.png';
import Border2 from '../assets/footer1.png';
import FallArmyworm from '../assets/fall_armyworm.png';
import Cutworm from '../assets/cutworm.png';
import OnionArmyworm from '../assets/onion_armyworm.png';
import Others from '../assets/others.png';

function HomePage() {
  const [menuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  // Show modal confirmation
  const confirmLogout = (e) => {
    e.preventDefault();
    setShowLogoutModal(true);
  };

  // Proceed with logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem('user');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleStartMonitoring = () => {
    navigate('/main');
  };

  return (
    <div className="home-page">
      <header className="header-bar">
        <img src={logo} className="header-logo" alt="OnionMap" />
        <nav className={`menu ${menuOpen ? 'active' : ''}`}>
          <ul className="menu-list">
            <li><Link to="/results">RESULTS</Link></li>
            <li><Link to="/manage">MANAGE</Link></li>
            <li><Link to="/about-us">ABOUT US</Link></li>
            <li>
              {/* 🔹 Link-style Logout that still opens modal */}
              <Link
                to="#"
                onClick={confirmLogout}
                className="logout-link"
              >
                LOGOUT
              </Link>
            </li>
          </ul>
        </nav>
      </header>

      <div className="picture-container">
        <img src={Border1} alt="Onion Design" className="onion-design" />
        <div className="overlay-text">
          <h2>Report sightings with our Pest</h2>
          <h2>Mapping System and help</h2>
          <h2>protect our harvest.</h2>
          <button className="start-button" onClick={handleStartMonitoring}>
            Start Monitoring
          </button>
        </div>
      </div>

      <div className="info-container">
        <h2>ONION PESTS</h2>
        <div className="pests-cards">
          <div className="pest-card">
            <img src={OnionArmyworm} alt="Onion Armyworm" />
            <h3>ONION ARMYWORM</h3>
            <p>Armyworms feed on leaves and seedlings, often causing significant damage by defoliating plants. 
            They can quickly move across fields in large groups, making them a serious threat.</p>
          </div>
          <div className="pest-card">
            <img src={Cutworm} alt="Cutworm" />
            <h3>CUTWORM</h3>
            <p>Cutworms are nocturnal pests that hide in the soil during the day and feed on the stems of young onion plants at night. 
              They cut the seedlings at the base, leading to plant collapse and significant crop loss if infestations are severe.</p>
          </div>
          <div className="pest-card">
            <img src={FallArmyworm} alt="Fall Armyworm" />
            <h3>FALL ARMYWORM</h3>
            <p>Fall armyworms are highly destructive caterpillars that feed on the leaves, stems, and reproductive parts of crops. 
                They create ragged holes in leaves and can cause severe defoliation, reducing crop yield and quality if not controlled early.</p>
          </div>
          <div className="pest-card">
            <img src={Others} alt="Others" />
            <h3>OTHERS</h3>
            <p>Other onion pests include onion thrips, which feed on the leaves and cause silvering, and onion maggots, which attack the roots and bulbs. 
              These pests can lead to reduced bulb size, poor plant health, and even total crop loss if not controlled effectively.</p>
          </div>
        </div>

        <div className="contact-us">
          <h2>CONTACT US</h2>
          <div className="contact-icons">
            <a href="mailto:qjbferrer@tip.edu.ph" target="_blank" rel="noopener noreferrer">
              <Mail title="Email" className="contact-icon email" />
            </a>
            <a href="https://youtube.com/@josephbryan5940" target="_blank" rel="noopener noreferrer">
              <Youtube title="YouTube" className="contact-icon youtube" />
            </a>
            <a href="https://facebook.com/josephbryanferrer.20" target="_blank" rel="noopener noreferrer">
              <Facebook title="Facebook" className="contact-icon facebook" />
            </a>
            <a href="https://github.com/qjbferrer" target="_blank" rel="noopener noreferrer">
              <GitHub title="GitHub" className="contact-icon github" />
            </a>
          </div>
        </div>
      </div>

      <footer className="footer">
        <img src={Border2} alt="Bottom Border" className="footer-image" />
      </footer>

      {/* ===== Logout Confirmation Modal ===== */}
      {showLogoutModal && (
        <div className="delete-confirm-modal">
          <div className="delete-confirm-content">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to log out of your account?</p>
            <div className="delete-confirm-buttons">
              <button
                className="delete-confirm-btn confirm"
                onClick={handleLogout}
              >
                Confirm
              </button>
              <button
                className="delete-confirm-btn cancel"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePage;
